var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCard2Your(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300,
    height: 120,
    viewBox: "0 0 300 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.374,
    y1: -0.329,
    x2: 0.981,
    y2: 0.946,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#84e0be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3cbe8e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 0.048,
    x2: 0.981,
    y2: 0.946,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ae47a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#811c75"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Icon_Bg",
    "data-name": "Icon Bg",
    width: 300,
    height: 120,
    rx: 20,
    transform: "translate(85 39)",
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Card_2",
    "data-name": "Card 2",
    transform: "translate(-1587 -927)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Icon_Bg-2",
    "data-name": "Icon Bg",
    width: 300,
    height: 120,
    rx: 20,
    transform: "translate(1587 927)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    transform: "translate(1502 888)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(295 74)",
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497585",
    "data-name": "Path 497585",
    d: "M7.5,35.957H28.485a3.507,3.507,0,0,0,3.5-3.495V11.495A3.507,3.507,0,0,0,28.485,8H7.5A3.507,3.507,0,0,0,4,11.495V32.462A3.507,3.507,0,0,0,7.5,35.957ZM11,14.989H24.987V28.968H11Zm31.481,6.989H70.459a3.495,3.495,0,1,0,0-6.989H42.476a3.495,3.495,0,1,0,0,6.989Zm0,34.946H7.5a3.495,3.495,0,1,0,0,6.989H42.476a3.495,3.495,0,1,0,0-6.989ZM70.459,42.946H7.5a3.495,3.495,0,1,0,0,6.989H70.459a3.495,3.495,0,1,0,0-6.989Zm0-13.979H42.476a3.495,3.495,0,1,0,0,6.989H70.459a3.495,3.495,0,1,0,0-6.989Z",
    transform: "translate(3.021 6.043)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497586",
    "data-name": "Path 497586",
    d: "M0,0H84V84H0Z",
    fill: "none"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard2Your);
export default __webpack_public_path__ + "static/media/Card2your.99958c0cf5daffaf94343edd39d745a7.svg";
export { ForwardRef as ReactComponent };